import React, { useState, useEffect, Fragment } from 'react';
import './index.scss';

export default function SearchLoader() {
  return (
    <div className="search-loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}
 